import { ThemeVariants } from '@stripcash/ui-kit/hoc/Theme';

import CookieAccepts from 'common/constants/cookieAccepts';
import { LS_THEME_ID } from 'common/constants/common';
import { LocalStorage } from 'common/helpers/Storage';

import getAcceptByCookie from './getAcceptByCookie';

const getInitialTheme = () => {
  if (getAcceptByCookie(CookieAccepts.ThemeAvailable)) {
    const themeId = LocalStorage.get(LS_THEME_ID) as ThemeVariants;
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const isSystemThemeDark = mediaQuery.matches;

    return (
      themeId || (isSystemThemeDark ? ThemeVariants.Dark : ThemeVariants.Light)
    );
  }

  return null;
};

export default getInitialTheme;
